module.exports = __webpack_public_path__ + "img/card_top.93deb332.png";